// Single source of truth for company branding & contact information.
// Used in headers, PDFs, WhatsApp summaries, page metadata.

export const COMPANY = {
  appName: "MKB ORDER APP",
  legalName: "MKB DESIGNER STUDIO PRIVATE LIMITED",
  address: "41, SHIBTALA STREET, 5TH FLOOR, BEHIND ICICI BANK KALAKAR STREET BRANCH, KOLKATA-700007",
  contact1: "7003798965",
  contact2: "9830314033",
  customerCare: "8240504320",
  email: "contact.mkbds@gmail.com",
  gst: "19AANCM1642E1ZG",
  logoUrl: "https://customer-assets.emergentagent.com/job_fabric-order-hub-5/artifacts/e5hdwzzx_MKB%20LOGO.png",
};

export const companyFooterText = () => [
  `*${COMPANY.legalName}*`,
  COMPANY.address,
  `Contact: ${COMPANY.contact1} / ${COMPANY.contact2}`,
  `Customer Care: ${COMPANY.customerCare}`,
  `Email: ${COMPANY.email}`,
  `GST: ${COMPANY.gst}`,
].join("\n");
